$(document).ready(function(){
    $(document).on('click','.purchase-option',function(){
        $('.purchase-option').removeClass('purchase-option--active');
        $(this).addClass('purchase-option--active');
        const clickedSub = $(this).attr('data-sub-type');
        $('.plan_card').find('input[data-radio-type="'+clickedSub+'"]').trigger('click');
        
    });

    $('.purchase-option[data-sub-type="selling_plan"]').trigger('click');
});